import moment from 'moment';

export const calendarEventDayKey = (date: Date) => {
	return moment(date).format('YYYY-MM-DD');
};
